import { v4 as uuid } from "uuid";

import { EntityTypes } from "../../EntityTypes";
import { ITopicResource } from "../../topics";
import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { mapRelationalValueAsIRI, RelationalValue } from "../../utils/filters";
import { IReflectiveAnalysisQuestion, IReflectiveAnalysisResource, ReflectiveAnalysisType } from "../types";

export interface IReflectiveAnalysisCreateMutationParameters {
    questions: IReflectiveAnalysisQuestion[];
    individualAssignment: RelationalValue<ITopicResource>;
    type: ReflectiveAnalysisType;
    uuid?: string;
}

export type IReflectiveAnalysisCreateMutationResult = IReflectiveAnalysisResource;

export const reflectiveAnalysisCreateMutation: IApiMutationFunction<IReflectiveAnalysisCreateMutationParameters> = ({
    uuid: providedUuid,
    questions,
    individualAssignment,
    type,
}) => {
    return {
        method: "POST",
        url: "/reflective_analyses",
        data: {
            questions,
            individualAssignment: mapRelationalValueAsIRI(EntityTypes.TOPIC, individualAssignment),
            type,
            uuid: providedUuid ?? uuid(),
        },
    };
};

export const useReflectiveAnalysisCreateMutation = createApiMutationHook<
    IReflectiveAnalysisCreateMutationParameters,
    IReflectiveAnalysisCreateMutationResult
>(reflectiveAnalysisCreateMutation);
